// extracted by mini-css-extract-plugin
export default {"marker":"Ewg4ZQ","dot":"YoJkeM","animateDot":"n2_FGX","wave":"lnQFx8","wave2":"qSvQSU","animationWave":"_2TyyPz","pin":"Xzlpg6"};